<template>
    <component v-if="raw" :is="tag" v-html="sanitizeHtml(translated)" />
    <component v-else :is="tag">
        {{ translated }}
    </component>
</template>
<script src="./TranslateWrapper.ts"></script>
